import * as React from "react";
import { merge, $ } from "glamor";
import { connect } from "react-redux";
import { fetchCatalog } from "actions/catalog";
import { fetchCatalogs, fetchCatalogsNextPage } from "actions/catalogs";
import { fetchEntries, fetchEntriesNextPage } from "actions/entries";
import { add as snackbarAdd } from "actions/snackbars";
import { fetchBrand } from "actions/collections";
import { withRouter, RouterState, InjectedRouter } from "react-router";
import { BrandPicker as SearchProducts } from "components/product-collection/product-collection-side-panel/product-collection-side-panel-brand-picker";
import { Catalogs } from "./catalogs";
import { AllBrands } from "./all-brands";
import { ShopCatalog } from "./catalog";
import { Search } from "./search";
import { formatMessage } from "lib/globalize-util";
import * as actions from "actions/collections";
import { parseSchema, productsInAssortment } from "helpers/product-collection";
import { fetchGlobalProducts, fetchNextGlobalProducts, resetGlobalProducts } from "actions/global-products";
import { List } from "immutable";
import * as PropTypes from "prop-types";
import type { IScope } from "reducers/scope";
import { Location } from "history";
import { View, CollectionKeys } from "constants/product-collection";
export const HEADER_HEIGHT = 48;

enum ShopType {
    AllBrands = "allBrands",
    Catalogs = "catalogs",
    Catalog = "catalog",
    GlobalSearch = "globalSearch",
}

interface IProps {
    app: any;
    location: Location;
    cartView: View;
    onFetchEntries: (catalogId, cacheKey, filters, fromAssortment?) => void;
    onFetchEntriesNextPage: (catalogId, nextPage, fromAssortment?) => void;
    onFetchCatalog: (id) => void;
    onSnackbarAdd: (params) => void;
    scope: IScope;
    brandEntities: any;
    brandIds: string[];
    catalogIds: string[];
    isFetchingCatalogs: boolean;
    catalogEntities: any;
    onFetchCatalogs: (query) => void;
    onFetchCatalogsNextPage: (nextPage) => void;
    catalogsNextPage: any;
    isFetchingBrand: boolean;
    onFetchBrand: (brandId) => void;
    catalogType: "linesheet" | "custom-list";
    router: RouterState & InjectedRouter;
    catalog: any;
    catalogs: any;
    entities: any;
    entries: any;
    isViewDefFetching: boolean;
    itemsId: string;
    items: List<any>;
    onAddItem: (params) => void;
    collection: any;
    collectionEditable: boolean;
    merchantId: string;
    onFetchGlobalProducts: (filters) => void;
    globalProducts: any;
    globalProductsIsFetching: boolean;
    globalProductNextPageQuery: any;
    onFetchNextGlobalProducts: (params) => void;
    itemDisplayProperty: List<any>;
}

export const ShopToolPanelComponent: React.FunctionComponent<IProps> = (
    {
        app,
        location,
        cartView,
        onFetchEntries,
        onFetchCatalog,
        onSnackbarAdd,
        scope,
        brandEntities,
        brandIds,
        catalogIds,
        isFetchingCatalogs,
        catalogEntities,
        onFetchCatalogs,
        onFetchCatalogsNextPage,
        catalogsNextPage,
        isFetchingBrand,
        onFetchBrand,
        catalogType,
        router,
        catalog,
        catalogs,
        entities,
        entries,
        isViewDefFetching,
        itemsId,
        items,
        onAddItem,
        onFetchEntriesNextPage,
        collection,
        collectionEditable,
        merchantId,
        onFetchGlobalProducts,
        globalProducts,
        globalProductsIsFetching,
        globalProductNextPageQuery,
        onFetchNextGlobalProducts,
        itemDisplayProperty,
        // tslint:disable-next-line: align
    },
    { me }
) => {
    const styles = React.useMemo(() => {
        return merge(
            {
                backgroundColor: "white",
                height: "100%",
                overflowY: "hidden",
            },
            $(" .brandPageHeader", {
                height: "100px",
                lineHeight: "24px",
                fontSize: "20px",
                display: "flex",
                justifyContent: "center",
                paddingTop: "50px",
            }),
            $(" .brandPageHeader svg", {
                marginRight: "10px",
            }),
            $(" .brandHeaderText", {
                lineHeight: "20px",
                fontSize: "16px",
                color: "black",
            }),
            $(" .shopHeader", {
                height: `${HEADER_HEIGHT}px`,
                maxHeight: `${HEADER_HEIGHT}px`,
                paddingLeft: "20px",
                display: "inline-flex",
                width: "100%",
            }),
            $(" .sidePanelBrandPicker", {
                paddingRight: "50px",
            }),
            $(" .ReactVirtualized__Grid__innerScrollContainer", {
                minHeight: "100%",
            })
        );
    }, []);
    const [shopType, setShopType] = React.useState<ShopType>();
    const [inAssortmentProducts, setInAssortmentProducts] = React.useState<{ [key: string]: string[] }>({});

    React.useEffect(() => {
        setInAssortmentProducts(productsInAssortment(items));
    }, [items]);

    React.useEffect(() => {
        const isCatalog = location.pathname.includes("/catalog/");
        const isSearch = location.pathname.includes("/search");
        if (!router.params.brand) {
            setShopType(ShopType.AllBrands);
        } else if (isCatalog) {
            setShopType(ShopType.Catalog);
        } else if (isSearch) {
            setShopType(ShopType.GlobalSearch);
        } else {
            setShopType(ShopType.Catalogs);
        }
    }, [catalog, router, location]);

    const { shopViewFields } = React.useMemo(() => {
        return parseSchema(itemDisplayProperty);
    }, [itemDisplayProperty]);

    const breadcrumbs = React.useMemo(() => {
        const { params } = router;
        const links: Array<{ displayName: string; path?: string }> = [];
        const { query } = location;
        let searchParams;
        let queryParams = "?mode=cart";

        if (query && query.filters) {
            try {
                searchParams = JSON.parse(query.filters as string).__search;
            } catch (error) {
                // Do nothing
            }
        }

        if (query && query.gridParams) {
            queryParams += `&gridParams=${query.gridParams}`;
        }

        if (params.brand) {
            links.push({
                displayName: scope.brand?.name,
                path: `/assortment/${params.id}/shop/brand/${scope.brand?._id}${queryParams}`,
            });

            if (params.catalog && catalog) {
                links.push({
                    displayName: catalog.title,
                    path: `/assortment/${params.id}/shop/brand/${scope.brand?._id}/catalog/${catalog.id}${queryParams}`,
                });
            }
        } else {
            links.push({
                displayName: formatMessage("All Brands"),
                path: `/assortment/${params.id}/shop`,
            });
        }

        if (searchParams) {
            links.push({
                displayName: formatMessage("Showing results for |searchParams|", { searchParams }),
            });
        }
        return links;
    }, [router, location, scope, catalog]);

    return cartView === View.History ? (
        <div
            style={{
                textAlign: "center",
                marginTop: "16px",
                color: "#585858",
            }}
        >
            {formatMessage("Unable to add products while in Version History")}
        </div>
    ) : (
        <div {...styles}>
            {shopType === ShopType.AllBrands && <AllBrands />}
            {shopType === ShopType.Catalogs && (
                <Catalogs
                    app={app}
                    location={location}
                    onFetchCatalog={onFetchCatalog}
                    onSnackbarAdd={onSnackbarAdd}
                    scope={scope}
                    brandEntities={brandEntities}
                    brandIds={brandIds}
                    catalogIds={catalogIds}
                    isFetchingCatalogs={isFetchingCatalogs}
                    catalogEntities={catalogEntities}
                    onFetchCatalogs={onFetchCatalogs}
                    onFetchCatalogsNextPage={onFetchCatalogsNextPage}
                    catalogsNextPage={catalogsNextPage}
                    isFetchingBrand={isFetchingBrand}
                    onFetchBrand={onFetchBrand}
                    catalogType={catalogType}
                    router={router}
                >
                    <SearchProducts
                        entities={brandEntities}
                        ids={brandIds}
                        isMobileOrPhablet={false}
                        location={location}
                        scope={scope}
                        sidePanelWidth={100}
                        hideIcon={true}
                        router={router}
                        selected={false}
                        catalog={catalog}
                        catalogs={catalogs}
                    />
                </Catalogs>
            )}
            {shopType === ShopType.Catalog && (
                <ShopCatalog
                    scope={scope}
                    router={router}
                    breadcrumbs={breadcrumbs}
                    catalog={catalog}
                    app={app}
                    entities={entities}
                    brandEntities={brandEntities}
                    entries={entries}
                    isViewDefFetching={isViewDefFetching}
                    itemsId={itemsId}
                    items={items}
                    location={location}
                    onAddItem={onAddItem}
                    onFetchEntries={onFetchEntries}
                    onFetchEntriesNextPage={onFetchEntriesNextPage}
                    onFetchCatalog={onFetchCatalog}
                    collection={collection}
                    inAssortmentProducts={inAssortmentProducts}
                    collectionEditable={collectionEditable}
                    shopViewFields={shopViewFields}
                >
                    <SearchProducts
                        entities={brandEntities}
                        ids={brandIds}
                        isMobileOrPhablet={false}
                        location={location}
                        scope={scope}
                        sidePanelWidth={100}
                        hideIcon={true}
                        router={router}
                        selected={false}
                        catalog={catalog}
                        catalogs={catalogs}
                    />
                </ShopCatalog>
            )}
            {shopType === ShopType.GlobalSearch && (
                <Search
                    merchantId={merchantId}
                    brandEntities={brandEntities}
                    onFetchGlobalProducts={onFetchGlobalProducts}
                    globalProducts={globalProducts}
                    globalProductsIsFetching={globalProductsIsFetching}
                    globalProductNextPageQuery={globalProductNextPageQuery}
                    inAssortmentProducts={inAssortmentProducts}
                    itemsId={itemsId}
                    items={items}
                    location={location}
                    onAddItem={onAddItem}
                    scope={scope}
                    router={router}
                    collectionEditable={collectionEditable}
                    onFetchNextGlobalProducts={onFetchNextGlobalProducts}
                    shopViewFields={shopViewFields}
                    breadcrumbs={breadcrumbs}
                    itemDisplayProperty={itemDisplayProperty}
                >
                    <SearchProducts
                        entities={brandEntities}
                        ids={brandIds}
                        isMobileOrPhablet={false}
                        location={location}
                        scope={scope}
                        sidePanelWidth={100}
                        hideIcon={true}
                        router={router}
                        selected={false}
                        catalog={catalog}
                        catalogs={catalogs}
                    />
                </Search>
            )}
        </div>
    );
};

ShopToolPanelComponent.contextTypes = { me: PropTypes.object.isRequired };

const mapStateToProps = (state, ownProps) => {
    const { query } = ownProps.location;
    const { cartView } = query;
    let catalog;
    if (state.catalog.result.length) {
        catalog = state.catalog.entities.catalogs[state.catalog.result];
    }
    const collection = state.mutate.snapshots && state.mutate.snapshots.get(ownProps.router.params.id);
    const merchantId = collection ? collection.getIn(["merchant_v1_id", "string_value"], "") : "";
    const itemsId = collection ? collection.getIn(["items", "ref", "object_id"]) : undefined;
    const items = state.mutate.snapshots && collection && state.mutate.snapshots.get(itemsId);
    const capabilities = state.collection?.driveItem?.capabilities;
    const collectionEditable = capabilities?.can_edit || false;
    const itemDisplayProperty = collection ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) : undefined;

    return {
        app: state.app,
        scope: state.scope,
        brandEntities: state.entities.brands,
        brandIds: state.collectionSidePanel.brands || [],
        cartView,
        catalogIds: state.catalogs.result || [],
        isFetchingCatalogs: state.catalogs.isFetching,
        catalogEntities: state.entities.catalogs,
        catalogsNextPage: state.catalogs.nextPage,
        isFetchingBrand: state.collectionSidePanel.isFetchingBrand,
        catalogType: ["linesheet", "custom-list"].includes(query.type) ? query.type : undefined,
        catalog,
        catalogs: state.catalogs.entities.catalogs,
        entities: state.entities,
        entries: state.entries.collections[ownProps.router.params.catalog] || {
            results: [],
            isFetching: false,
            hasMoreResults: false,
            isBulkDeleting: false,
        },
        isViewDefFetching: state.views.isFetching,
        itemsId,
        items,
        collection,
        collectionEditable,
        merchantId,
        globalProducts: state.globalProducts.products || List(),
        globalProductsIsFetching: state.globalProducts.isFetching,
        globalProductNextPageQuery: state.globalProducts.nextPageQuery,
        itemDisplayProperty,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onFetchCatalog: (catalogId) => dispatch(fetchCatalog(catalogId)),
        onFetchEntries: (catalogId, cacheKey, filters) =>
            dispatch(fetchEntries(catalogId, cacheKey, catalogId, filters, undefined, false, true)),
        onSnackbarAdd: (params) => dispatch(snackbarAdd(params)),
        onFetchCatalogs: (query) => dispatch(fetchCatalogs(query)),
        onFetchCatalogsNextPage: (nextPage) => dispatch(fetchCatalogsNextPage(nextPage)),
        onFetchBrand: (brandId) => dispatch(fetchBrand(brandId)),
        onAddItem: (params) => dispatch(actions.addItem(params)),
        onFetchEntriesNextPage: (catalogId, nextPage) => dispatch(fetchEntriesNextPage(catalogId, nextPage, true)),
        onFetchGlobalProducts: (params) => dispatch(fetchGlobalProducts(params)),
        onFetchNextGlobalProducts: (params) => dispatch(fetchNextGlobalProducts(params)),
        onResetGlobalProducts: (params) => dispatch(resetGlobalProducts(params)),
    };
};

export const ShopToolPanel = withRouter(connect(mapStateToProps, mapDispatchToProps)(ShopToolPanelComponent));
